<main *ngIf="timeLeft > 0">  
  <div class="text-center pb-1">
    <span>You have been logged out and will be redirected to login page in {{ timeLeft }} seconds...</span>
    <button class="ms-2 basic-button-base" (click)="redirectToLogin()">Skip countdown</button>
  </div>
  <div class="embed-container">
    <iframe class="iframe-embed" frameBorder="0" title="marketing" src="https://zint-webinar-registration.zint.io/"></iframe>
  </div>
</main>
